import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { AttributeGroup } from 'src/app/shared/models/attributes/attributeGroup';
import { map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { ApiVersions } from './api-version';
import { AttributeGroupWrite } from '../models/attributes/attributeGroupWrite';

@Injectable()
export class AttributeGroupService extends BaseService {
  private basePath = 'attributeGroups';

  protected _subject: BehaviorSubject<AttributeGroup[]> = new BehaviorSubject<AttributeGroup[]>(
    null
  );
  protected _observable: Observable<AttributeGroup[]> = this._subject.asObservable();
  public readonly attributeGroup = new BehaviorSubject<AttributeGroup>(null);

  constructor() {
    super();
  }

  public get attributeGroups(): Observable<AttributeGroup[]> {
    return this._observable;
  }

  public getAll() {
    let parse = (data: any) => data?.map((group) => AttributeGroup.parse(group));

    let obs = this.get(this.basePath).pipe(map(parse));

    obs.subscribe((groups) => {
      this._subject.next(groups);
    });
  }

  public getAttributeGroup(attributeGroupId: string) {
    this.get(this.basePath.concat(`/${attributeGroupId}`)).subscribe((group) => {
      if (group) {
        this.attributeGroup.next(group);
      }
    });
  }

  public updateAttributeGroup(attributeGroup: AttributeGroupWrite) {
    let body = JSON.stringify(attributeGroup);
    this.put(this.basePath.concat(`/${attributeGroup.id}`), body, null, ApiVersions.v0_1).subscribe(
      (group) => {
        if (group) {
          this.openSnackBar('Attribute Group Updated', true);
          this.attributeGroup.next(group);
          this.getAll();
        }
      }
    );
  }

  public updateAttributeGroupRank(attributeGroupId: string, isMovingUp: boolean) {
    this.put(this.basePath.concat(`/${attributeGroupId}/rank/${isMovingUp}`)).subscribe(
      (groups) => {
        if (groups) {
          this._subject.next(groups);
        }
      }
    );
  }

  public deleteAttributeGroup(attributeGroupId: string) {
    this.delete(this.basePath.concat(`/${attributeGroupId}`)).subscribe((groups) => {
      if (groups) {
        this._subject.next(groups);
      }
    });
  }

  public createAttributeGroup(attributeGroup: AttributeGroupWrite) {
    let body = JSON.stringify(attributeGroup);
    this.post(this.basePath, body, null, ApiVersions.v0_1).subscribe((group) => {
      if (group) {
        this.openSnackBar('Attribute Group Created', true);
        this.attributeGroup.next(group);
        this.getAll();
      }
    });
  }
}
